document.addEventListener('DOMContentLoaded', () => {
    mainNavigation();
    setupMobileMenuToggle();
    setupDocumentClickListener();
});

function mainNavigation() {
    const menuItems = document.querySelectorAll('li.menu-item-has-children');

    Array.prototype.forEach.call(menuItems, function(el) {
        el.querySelector('a').addEventListener('click', function(event) {
            openDropdownMenu.call(this, event);
        });
        el.querySelector('a').addEventListener('keyup', dropdownKeyupHandler);
        el.querySelector('a').addEventListener('keydown', dropdownKeydownHandler);
    });
}

function openDropdownMenu(event) {
    event.preventDefault();
    const currentDropdown = this.parentNode;

    // Close all dropdowns except for the current one
    document.querySelectorAll('li.menu-item-has-children').forEach(function(item) {
        if (item !== currentDropdown) {
            item.classList.remove('open');
            item.querySelector('a').setAttribute('aria-expanded', 'false');
        }
    });

    const isOpen = currentDropdown.classList.contains('open');
    currentDropdown.classList.toggle('open', !isOpen);
    this.setAttribute('aria-expanded', String(!isOpen));
}

function dropdownKeydownHandler(event) {
    if (event.keyCode === 32 || event.keyCode === 13) {
        event.preventDefault();
        this.click();
    }
}

function dropdownKeyupHandler(event) {
    if (event.keyCode === 32) {
        event.preventDefault();
    }
}

function setupMobileMenuToggle() {
    const menuToggle = document.getElementById('menu-toggle');
    const mobileNav = document.querySelector('.main-navigation-wrapper');

    menuToggle.addEventListener('click', function() {
        toggleMobileMenu(mobileNav, this);
    });
}

function toggleMobileMenu(nav, toggleButton) {
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
    toggleButton.setAttribute('aria-expanded', !isExpanded);
    nav.classList.toggle('open');

    // Toggle visibility of icons
    const menuIcon = toggleButton.querySelector('.menu-icon');
    const closeIcon = toggleButton.querySelector('.close-icon');

    if (isExpanded) {
        menuIcon.style.display = 'block';
        closeIcon.style.display = 'none';
    } else {
        menuIcon.style.display = 'none';
        closeIcon.style.display = 'block';
    }
}


function setupDocumentClickListener() {
    document.addEventListener('click', function(event) {
        // Close all dropdowns if click is outside of menu items
        if (!event.target.closest('.menu-item-has-children')) {
            document.querySelectorAll('.menu-item-has-children.open').forEach(function(item) {
                item.classList.remove('open');
                item.querySelector('a').setAttribute('aria-expanded', 'false');
            });
        }
    });
}
